// @flow
import React, { Component } from 'react'
import Stars from './stars.js'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import './style/styles.scss'
import type { SemanticUIColors } from './semanticUIColors'

type Props = {
  averageRating?: number,
  inverted: boolean,
  question: string,
  ratingHandler: (question: string, selectedRating: number) => void,
  starAmount: number,
  starColor: SemanticUIColors,
  votingIsOver: boolean
}

type State = {
  currentlySelectedRating: number
}

/**
 * Renders a single question, including the interactive stars
 *
 * @param {Props} props
 * @param {number} [props.averageRating]
 * @param {boolean} [props.inverted=false]
 * @param {string} props.question
 * @param {Function} props.ratingHandler
 * @param {number} [props.starAmount=5]
 * @param {SemanticUIColors} [props.starColor=yellow]
 * @param {boolean} [props.votingIsOver=false]
 */
export class Question extends Component<Props, State> {
  static defaultProps = {
    inverted: false,
    starAmount: 5,
    starColor: 'yellow',
    votingIsOver: false
  }

  state = {
    currentlySelectedRating: -1
  }

  /**
   * Handle clicks on a star
   */
  handleClick = (selectedRating: number) => {
    if (!this.props.votingIsOver) {
      this.setState({
        currentlySelectedRating: selectedRating
      })
      this.props.ratingHandler(this.props.question, selectedRating)
    }
  }

  render() {
    const votingIsActiveText = (
      <td className={'voting-question'}>{this.props.question}</td>
    )
    const votingIsOverText = (
      <td className={'voting-question'}>
      {/* Sie haben ihre Wertung erfolgreich abgegeben. So schneidet der Beitrag
        im Durchschnitt ab: */}
        Das Voting für die Wahlchallenge ist beendet. So hat der Beitrag im Durchschnitt abgeschnitten:
      </td>
    )

    return (
      <tr>
        {this.props.votingIsOver ? votingIsOverText : votingIsActiveText}
        {/* <td className={'voting-question'}>{this.props.question}</td> */}
        <td className={`single line right aligned`}>
          <Stars
            averageRating={this.props.averageRating}
            clickHandler={this.handleClick}
            inverted={this.props.inverted}
            currentlySelectedRating={this.state.currentlySelectedRating}
            starAmount={this.props.starAmount}
            starColor={this.props.starColor}
            votingIsOver={this.props.votingIsOver}
          />
        </td>
      </tr>
    )
  }
}

export default Question
